import {
  authHeader,
  config,
  options,
  handleResponse,
  handleError,
} from "../common/helpers";

const appService = {
  getFeatures,
};

function getFeatures() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    credentials: "include", // Required for cookie-based auth in production
  };
  const serviceurl = options(config.apiUrl + "/featuretoggles");
  return fetch(serviceurl, requestOptions).then(handleResponse, handleError);
}
export const getCountryList = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(`${config.apiUrl}/country`);
  return fetch(url, requestOptions).then(handleResponse, handleError);
};

export const getActivation = (data) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  const url = `${config.apiUrl}/activate`;
  return fetch(url, requestOptions).then(handleResponse, handleError);
};

export const getServiceStatus = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(`${config.apiUrl}/status`);
  return fetch(url, requestOptions).then(handleResponse, handleError);
};

export default appService;
